import React, { Fragment } from "react"
import { List } from "semantic-ui-react";
import { useSchemaTranslation } from "../../../useSchemaTranslation";


interface ErrorListProps {
    rawErrors: string[]
};

export const ErrorList: React.FC<ErrorListProps> = ({ rawErrors }) => {
    const { t } = useSchemaTranslation();

    return (
        <Fragment>
            {rawErrors.length > 0 && (
                <List>
                    {rawErrors.map((error, i: number) => {
                        return (
                            <List.Item key={i}>
                                <span style={{ color: "#9F3A38" }}>{t(error)}</span>
                            </List.Item >
                        );
                    })}
                </List>
            )}
        </Fragment>
    )
}